import { StyleSheet } from "react-native";

import { kColors } from "src/kColors";

import { PdSend } from "src/components/Icons";
import { ComposerToolbarIconButton } from "./components";
import { useComposer } from "./utils";

const SendButton: React.FC = () => {
  const { onSend, canSend } = useComposer();

  return (
    <ComposerToolbarIconButton
      icon={<PdSend style={styles.composerIconSend} />}
      isDisabled={!canSend}
      onPress={onSend}
    />
  );
};

export default SendButton;

const styles = StyleSheet.create({
  composerIconSend: {
    color: kColors.gray500,
    width: 15,
  },
});
